module.exports = __webpack_public_path__ + "img/LamdeiniLearning-319.2a4eaa03.jpg";